var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25H9.5C9.91421 3.25 10.25 3.58579 10.25 4C10.25 4.41421 9.91421 4.75 9.5 4.75H4.75V9.5C4.75 9.91421 4.41421 10.25 4 10.25C3.58579 10.25 3.25 9.91421 3.25 9.5V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 20C3.25 20.4142 3.58579 20.75 4 20.75H9.5C9.91421 20.75 10.25 20.4142 10.25 20C10.25 19.5858 9.91421 19.25 9.5 19.25H4.75V14.5C4.75 14.0858 4.41421 13.75 4 13.75C3.58579 13.75 3.25 14.0858 3.25 14.5V20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 4C20.75 3.58579 20.4142 3.25 20 3.25H14.5C14.0858 3.25 13.75 3.58579 13.75 4C13.75 4.41421 14.0858 4.75 14.5 4.75H19.25V9.5C19.25 9.91421 19.5858 10.25 20 10.25C20.4142 10.25 20.75 9.91421 20.75 9.5V4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H20V10",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 20C20.75 20.4142 20.4142 20.75 20 20.75H14.5C14.0858 20.75 13.75 20.4142 13.75 20C13.75 19.5858 14.0858 19.25 14.5 19.25H19.25V14.5C19.25 14.0858 19.5858 13.75 20 13.75C20.4142 13.75 20.75 14.0858 20.75 14.5V20Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.75C9.75736 8.75 8.75 9.75736 8.75 11C8.75 12.2426 9.75736 13.25 11 13.25C12.2426 13.25 13.25 12.2426 13.25 11C13.25 9.75736 12.2426 8.75 11 8.75ZM7.25 11C7.25 8.92893 8.92893 7.25 11 7.25C13.0711 7.25 14.75 8.92893 14.75 11C14.75 13.0711 13.0711 14.75 11 14.75C8.92893 14.75 7.25 13.0711 7.25 11Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4697 16.5304L12.4697 13.5304L13.5304 12.4697L16.5304 15.4697L15.4697 16.5304Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4H4V10",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14V20H10",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H20V14",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewDetail);
export default __webpack_public_path__ + "static/media/PreviewDetail.aba487714d9c570343f10a4678b47de6.svg";
export { ForwardRef as ReactComponent };